(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-toast"] && !Shopify.designMode) return;
  try {
    class VlpToast extends HTMLElement {
    connectedCallback() {
      this.textEl = this.querySelector('.vlp-toast__text');
      this.suffix = this.dataset.added || '';
      this.timer = null;
      document.addEventListener('vlp:cart:added', (event) => {
        const title = event.detail && event.detail.title ? event.detail.title : '';
        this.show(title);
        this.refreshCount();
      });
      document.addEventListener('vlp:cart:error', (event) => {
        const message = event.detail && event.detail.message ? event.detail.message : '';
        this.showError(message);
      });
    }

    reveal(duration) {
      this.hidden = false;
      this.classList.add('is-visible');
      clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        this.classList.remove('is-visible');
        this.hidden = true;
      }, duration);
    }

    show(title) {
      this.classList.remove('is-error');
      if (this.textEl) {
        this.textEl.textContent = title ? (title + ' ' + this.suffix).trim() : this.suffix;
      }
      this.reveal(2400);
    }

    showError(message) {
      this.classList.add('is-error');
      if (this.textEl) {
        this.textEl.textContent = message;
      }
      this.reveal(3200);
    }

    async refreshCount() {
      try {
        const response = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
        const cart = await response.json();
        document.querySelectorAll('[data-cart-count]').forEach((el) => {
          el.textContent = cart.item_count;
          if (cart.item_count > 0) {
            el.removeAttribute('hidden');
          } else {
            el.setAttribute('hidden', '');
          }
        });
      } catch (error) {
        /* no-op */
      }
    }
  }

  if (!customElements.get('vlp-toast')) {
    customElements.define('vlp-toast', VlpToast);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    class ProductCardMedia extends HTMLElement {
    connectedCallback() {
      this.images = Array.from(this.querySelectorAll('.vlp-card__img'));
      if (this.images.length < 2) return;
      this.index = 0;
      this.timer = null;

      const prev = this.querySelector('[data-card-prev]');
      const next = this.querySelector('[data-card-next]');
      if (prev) {
        prev.addEventListener('click', (event) => {
          event.preventDefault();
          this.stop();
          this.show(this.index - 1);
        });
      }
      if (next) {
        next.addEventListener('click', (event) => {
          event.preventDefault();
          this.stop();
          this.show(this.index + 1);
        });
      }

      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      if (window.matchMedia('(hover: hover)').matches) {
        this.addEventListener('mouseenter', () => this.start(800));
        this.addEventListener('mouseleave', () => this.reset());
      } else if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                this.start(1300);
              } else {
                this.reset();
              }
            });
          },
          { threshold: 0.6 }
        );
        this.observer.observe(this);
      }
    }

    disconnectedCallback() {
      this.stop();
      if (this.observer) this.observer.disconnect();
    }

    show(target) {
      this.images[this.index].classList.remove('is-active');
      this.index = (target + this.images.length) % this.images.length;
      this.images[this.index].classList.add('is-active');
    }

    start(interval) {
      if (this.timer) return;
      this.timer = setInterval(() => this.show(this.index + 1), interval || 1000);
    }

    stop() {
      clearInterval(this.timer);
      this.timer = null;
    }

    reset() {
      this.stop();
      this.show(0);
    }
  }

  class ProductQuickAdd extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('[data-quick-add]');
      if (!this.button) return;
      this.button.addEventListener('click', (event) => {
        event.preventDefault();
        this.add();
      });
    }

    async add() {
      const id = this.dataset.variantId;
      if (!id) {
        window.location.href = this.dataset.productUrl;
        return;
      }
      this.button.setAttribute('disabled', '');
      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
        });
        if (!response.ok) throw new Error('add-to-cart failed');
        await response.json();
        document.dispatchEvent(
          new CustomEvent('vlp:cart:added', { detail: { title: this.dataset.productTitle } })
        );
      } catch (error) {
        window.location.href = this.dataset.productUrl;
      } finally {
        this.button.removeAttribute('disabled');
      }
    }
  }

  if (!customElements.get('product-card-media')) {
    customElements.define('product-card-media', ProductCardMedia);
  }
  if (!customElements.get('product-quick-add')) {
    customElements.define('product-quick-add', ProductQuickAdd);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["scroll-reveal"] && !Shopify.designMode) return;
  try {
    (function () {
    var root = document.documentElement;

    var revealWithin = function (scope) {
      (scope || document).querySelectorAll('.vlp-reveal').forEach(function (el) {
        el.classList.add('is-visible');
      });
    };

    // Theme editor: never hide content. Reveal everything immediately and also
    // reveal any section the merchant adds live (fires shopify:section:load).
    if (window.Shopify && window.Shopify.designMode) {
      revealWithin(document);
      document.addEventListener('shopify:section:load', function (event) {
        revealWithin(event.target);
      });
      return;
    }

    if (!root.classList.contains('vlp-anim')) return;

    var elements = document.querySelectorAll('.vlp-reveal');
    if (!elements.length) return;

    var revealAll = function () {
      elements.forEach(function (el) {
        el.classList.add('is-visible');
      });
    };

    try {
      if (!('IntersectionObserver' in window)) {
        revealAll();
        return;
      }

      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-visible');
              observer.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.12, rootMargin: '0px 0px -8% 0px' }
      );

      elements.forEach(function (el) {
        observer.observe(el);
      });

      try {
        localStorage.setItem('vlp_seen', '1');
      } catch (e) {
        /* storage unavailable */
      }
    } catch (e) {
      revealAll();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
